import React, { useState, useEffect } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  AppBar,
  Toolbar,
  List,
  ListItem,
  ListItemText,
  Container,
  CssBaseline,
  Typography,
  IconButton,
  Badge,
  Popover,
  Chip,
  ListItemIcon,
  Box,
} from "@mui/material";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import Page2 from "./Page2";
import Page3 from "./Page3";
import Page4 from "./Page4";
import Page7 from "./Page7";
import Page8 from "./Page8";
import Page9 from "./Page9";
import Page10 from "./Page10";
import Page11 from "./Page11";
import Page12 from "./Page12";
import Page13 from "./Page13";
import Page14 from "./Page14";
import Page15 from "./Page15";
import Page16 from "./Page16";
import Page17 from "./Page17";
import Page18 from "./Page18";
import Page19 from "./Page19";
import Scadentar from "./scadentar";
import ScadentarPaymentPlannedCheckPage from "./ScadentarPaymentPlannedCheckPage";
import ScadentarFurnizoriPage from "./ScadentarFurnizoriPage";
import ScadentarFurnizorProfilePage from "./ScadentarFurnizorProfilePage";
import InvestitiiPage from "./InvestitiiPage";
import Page20 from "./Page20";
import Page21 from "./Page21";
import Page22 from "./Page22";
import Page23 from "./Page23";
import ContracteZoho from "./ContracteZoho";
import Coupons from "./Coupons";
import Vinted from "./vinted";
import StocManager from "./StocManager";
import MobileStocManager from "./MobileStocManager";
import StocManagerLayer from "./StocManagerLayer";
import Login from "./login";
import Monitoring from "./Monitoring";
import CerereRestituit from "./cerere_restituit";
import LuxuraAIMain from "./luxura_ai_main.js";
import SEOAttributesPage from "./wooAttributesProxyFE";
import SEOProductsPage from "./wooAttributesProductsFE";
import WaitingListPage from "./WaitingListPage";
import styled from "styled-components";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MenuIcon from "@mui/icons-material/Menu";
import DashboardIcon from "@mui/icons-material/Dashboard";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import BuildIcon from "@mui/icons-material/Build";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ReceiptIcon from "@mui/icons-material/Receipt";
import BookIcon from "@mui/icons-material/Book";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import InventoryIcon from "@mui/icons-material/Inventory";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArticleIcon from "@mui/icons-material/Article";
import MenuBookIcon from "@mui/icons-material/MenuBook"; // Adăugat importul pentru Jurnale
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SearchIcon from "@mui/icons-material/Search";
import CategoryIcon from "@mui/icons-material/Category";
import { AuthProvider, useAuth } from "./AuthContext";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ScienceIcon from "@mui/icons-material/Science";
import FolderProducts from "./FolderProducts"; // ajustează calea dacă e în altă locație
import MobileFolderProducts from "./MobileFolderProducts";
import MobileFolderGroups from "./MobileFolderGroups";
import ProductsInventoryDetails from "./ProductsInventoryDetails";
import MobileProductsInventoryDetails from "./MobileProductsInventoryDetails";
import MobileMarketingTags from "./MobileMarketingTags";
import MobileScan from "./MobileScan";

const drawerExpandedWidth = 260;
const drawerCollapsedWidth = 88;

const StyledDrawer = styled(MuiDrawer)`
  width: ${({ $collapsed }) =>
    $collapsed ? `${drawerCollapsedWidth}px` : `${drawerExpandedWidth}px`};
  flex-shrink: 0;
  white-space: nowrap;

  & .MuiDrawer-paper {
    width: ${({ $collapsed }) =>
      $collapsed ? `${drawerCollapsedWidth}px` : `${drawerExpandedWidth}px`};
    margin-top: 64px;
    padding: ${({ $collapsed }) =>
      $collapsed ? "16px 0 24px" : "24px 0 32px"};
    background: linear-gradient(
      145deg,
      rgba(9, 16, 35, 0.92),
      rgba(12, 23, 45, 0.88)
    );
    color: #f8fafc;
    border-right: 1px solid rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(14px);
    transition:
      width 0.3s ease,
      padding 0.3s ease;
    overflow-x: hidden;
  }

  & .MuiListItemIcon-root {
    color: #94a3b8;
    min-width: ${({ $collapsed }) => ($collapsed ? "0" : "44px")};
    justify-content: ${({ $collapsed }) =>
      $collapsed ? "center" : "flex-start"};
    transition:
      min-width 0.3s ease,
      color 0.3s ease;
  }

  &.collapsed:hover .MuiDrawer-paper {
    width: ${drawerExpandedWidth}px;
    box-shadow: 12px 0 32px rgba(15, 23, 42, 0.45);
  }

  &.collapsed .MuiListItemText-root {
    opacity: 0;
    max-width: 0;
    transition:
      opacity 0.2s ease,
      max-width 0.3s ease;
  }

  &.collapsed:hover .MuiListItemText-root {
    opacity: 1;
    max-width: 180px;
  }

  &.collapsed .drawer-toggle-label {
    opacity: 0;
  }

  &.collapsed:hover .drawer-toggle-label {
    opacity: 1;
  }

  & .drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px 16px 20px;
  }

  &.collapsed .drawer-header {
    justify-content: center;
    padding-left: 0;
    padding-right: 0;
  }

  @media (max-width: 600px) {
    & .MuiDrawer-paper {
      margin-top: 64px;
      width: 80vw;
    }
  }
`;

const StyledAppBar = styled(MuiAppBar)`
  z-index: 1201;
  background: radial-gradient(circle at top, #0b1c3d, #101b30 60%) !important;
  box-shadow: 0 12px 40px rgba(3, 7, 18, 0.75);
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
  backdrop-filter: blur(14px);
`;

const StyledContainer = styled(Container)`
  padding-top: 120px;
  padding-bottom: 40px;
  box-sizing: border-box;
  min-height: 100vh;
  width: 100%;
  max-width: 100% !important;
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  transition: padding 0.3s ease;
  padding-left: 0;
  padding-right: 16px;
  overflow-x: clip;

  @media (max-width: 900px) {
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 96px;
  }

  @media (max-width: 600px) {
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 88px;
  }
`;

const LayoutWrapper = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: stretch;
  overflow-x: clip;
`;

const MainContent = styled.main`
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
  padding-left: clamp(8px, 1.2vw, 18px);
  transition: padding-left 0.3s ease;
  box-sizing: border-box;
  overflow-x: clip;
`;

const AppBackground = styled.div`
  min-height: 100vh;
  width: 100%;
  background:
    radial-gradient(
      circle at 15% 20%,
      rgba(83, 104, 223, 0.35),
      transparent 35%
    ),
    radial-gradient(circle at 80% 0%, rgba(67, 198, 172, 0.3), transparent 45%),
    linear-gradient(135deg, #020617 0%, #0f172a 45%, #111827 100%);
  padding-bottom: 48px;
  overflow-x: clip;
`;

const ContentCard = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 32px;
  padding: 32px;
  min-height: calc(100vh - 200px);
  box-shadow: 0 35px 80px rgba(15, 23, 42, 0.35);
  backdrop-filter: blur(12px);
  overflow-x: clip;
  transition:
    box-shadow 0.3s ease,
    transform 0.3s ease;

  &:hover {
    box-shadow: 0 45px 95px rgba(15, 23, 42, 0.4);
  }

  @media (max-width: 900px) {
    min-height: auto;
    padding: 24px;
    border-radius: 24px;
  }

  @media (max-width: 600px) {
    padding: 16px;
    border-radius: 20px;
  }
`;

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, isAuthReady } = useAuth();
  const location = useLocation();

  if (!isAuthReady) {
    return null;
  }

  return isAuthenticated ? (
    children
  ) : (
    <Navigate to="/login" replace state={{ from: location }} />
  );
};

function App() {
  const [currentPage, setCurrentPage] = useState("Monitoring");
  const [anchorEl, setAnchorEl] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showFinanciar, setShowFinanciar] = useState(false);
  const [showAutoFacturi, setShowAutoFacturi] = useState(false);
  const [showLLP, setShowLLP] = useState(false);
  const [showDeconturi, setShowDeconturi] = useState(false);
  const [showAchiztii, setShowAchiztii] = useState(false);
  const [showAdministrativ, setShowAdministrativ] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  const effectiveCollapsed = !isMobile && isCollapsed;
  const navItemBaseStyle = {
    margin: "6px 16px",
    borderRadius: "16px",
    paddingLeft: effectiveCollapsed ? "12px" : "20px",
    paddingRight: effectiveCollapsed ? "12px" : "12px",
    color: "#dbeafe",
    transition: "all 0.3s ease",
  };

  const sectionToggleStyle = {
    ...navItemBaseStyle,
    fontWeight: 600,
    background: "rgba(255, 255, 255, 0.05)",
  };

  const nestedToggleStyle = {
    ...sectionToggleStyle,
    marginLeft: "28px",
    marginRight: "24px",
  };

  const getNavItemStyle = (page) => ({
    ...navItemBaseStyle,
    background:
      currentPage === page
        ? "linear-gradient(135deg, #f8ffae 0%, #43c6ac 100%)"
        : "rgba(255, 255, 255, 0.02)",
    color: currentPage === page ? "#0f172a" : "#cbd5f5",
    boxShadow:
      currentPage === page ? "0 15px 35px rgba(67, 198, 172, 0.35)" : "none",
    transform: currentPage === page ? "translateY(-1px)" : "none",
  });

  const getNestedNavItemStyle = (page) => ({
    ...getNavItemStyle(page),
    marginLeft: "36px",
    marginRight: "24px",
  });

  const getNavIconStyle = (page) => ({
    color: currentPage === page ? "#0f172a" : "#a5b4fc",
    transition: "color 0.3s ease",
  });

  const getToggleStyle = (isOpen, nested = false) => ({
    ...(nested ? nestedToggleStyle : sectionToggleStyle),
    background: isOpen
      ? "rgba(148, 163, 184, 0.2)"
      : "rgba(255, 255, 255, 0.05)",
  });

  const getToggleIconStyle = (isOpen) => ({
    color: isOpen ? "#f8fafc" : "#94a3b8",
    transition: "color 0.3s ease",
  });

  useEffect(() => {
    if (!isMobile) {
      setIsDrawerOpen(true);
    } else {
      setIsDrawerOpen(false);
    }
  }, [isMobile]);

  const handleDrawerToggle = (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    if (isMobile) {
      setIsDrawerOpen(!isDrawerOpen);
    } else {
      setIsCollapsed((prev) => !prev);
    }
  };

  const handleCollapseToggle = (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    setIsCollapsed((prev) => !prev);
  };

  useEffect(() => {
    const savedPage = localStorage.getItem("currentPage");
    const currentPath = window.location.pathname;
    if (isMobile) {
      setCurrentPage("MobileStocManager");
    } else if (currentPath === "/scadentar-furnizori") {
      setCurrentPage("ScadentarFurnizori");
      localStorage.setItem("currentPage", "ScadentarFurnizori");
    } else if (savedPage) {
      setCurrentPage(savedPage);
    } else {
      setCurrentPage("Monitoring");
    }
  }, [isMobile]);

  const handleNotificationClick = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setAnchorEl(null);
  };

  const isNotificationOpen = Boolean(anchorEl);
  useEffect(() => {
    const handleNewProductNotification = (event) => {
      const { issueId, summary } = event.detail || {};
      const timestamp = new Date().toLocaleTimeString("ro-RO", {
        hour: "2-digit",
        minute: "2-digit",
      });
      setNotifications((prev) => {
        const next = [
          {
            id: `${Date.now()}-${issueId || Math.random()}`,
            message: `Produs nou în tabul "Created": ${
              summary || issueId || "necunoscut"
            }`,
            timestamp,
          },
          ...prev,
        ];
        return next.slice(0, 10);
      });
    };

    window.addEventListener(
      "new-product-created",
      handleNewProductNotification,
    );
    return () => {
      window.removeEventListener(
        "new-product-created",
        handleNewProductNotification,
      );
    };
  }, []);

  const TopBar = () => {
    const { logout } = useAuth();
    const version = "v5.4.9.18"; // Aici poți actualiza versiunea aplicației

    const handleLogout = () => {
      logout();
    };

    return (
      <StyledAppBar position="fixed">
        <Toolbar>
          <IconButton
            type="button"
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap style={{ flexGrow: 1 }}>
            BackOffice Luxura
          </Typography>
          <Chip
            label={`Version ${version}`}
            color="primary"
            style={{
              marginLeft: "8px",
              backgroundColor: "#fff",
              color: "#3f51b5",
            }}
          />
          <IconButton
            type="button"
            color="inherit"
            onClick={handleNotificationClick}
          >
            <Badge
              badgeContent={notifications.length}
              color="secondary"
              showZero
            >
              <NotificationsIcon />
            </Badge>
          </IconButton>
          <Popover
            open={isNotificationOpen}
            anchorEl={anchorEl}
            onClose={handleNotificationClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <Box sx={{ p: 2, maxWidth: 320 }}>
              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                Notificările tale
              </Typography>
              {notifications.length === 0 ? (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ py: 1 }}
                >
                  Nu există notificări noi.
                </Typography>
              ) : (
                <List
                  dense
                  sx={{
                    maxHeight: 260,
                    overflowY: "auto",
                    width: "100%",
                  }}
                >
                  {notifications.map((notification) => (
                    <ListItem
                      key={notification.id}
                      alignItems="flex-start"
                      sx={{
                        borderRadius: 2,
                        mb: 1,
                        background: "rgba(148,163,184,0.08)",
                      }}
                    >
                      <ListItemText
                        primary={notification.message}
                        secondary={notification.timestamp}
                        primaryTypographyProps={{
                          variant: "body2",
                          fontWeight: 600,
                          color: "#0f172a",
                        }}
                        secondaryTypographyProps={{
                          variant: "caption",
                          color: "text.secondary",
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              )}
            </Box>
          </Popover>
          <IconButton type="button" color="inherit" onClick={handleLogout}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </StyledAppBar>
    );
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    localStorage.setItem("currentPage", page);
  };

  const renderPageLayout = (children) => (
    <LayoutWrapper>
      <StyledDrawer
        className={effectiveCollapsed ? "collapsed" : ""}
        variant={isMobile ? "temporary" : "permanent"}
        open={isMobile ? isDrawerOpen : true}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        $collapsed={effectiveCollapsed}
      >
        <div className="drawer-header">
          {!effectiveCollapsed && (
            <Typography
              variant="subtitle2"
              className="drawer-toggle-label"
              style={{
                textTransform: "uppercase",
                letterSpacing: 1,
                color: "#ffffff",
              }}
            >
              Navigare
            </Typography>
          )}
          <IconButton
            type="button"
            onClick={handleCollapseToggle}
            size="small"
            disabled={isMobile}
            style={{
              color: "#f8fafc",
              marginLeft: effectiveCollapsed ? 0 : 8,
              opacity: isMobile ? 0.4 : 1,
            }}
          >
            {effectiveCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </div>
        <List>
          <ListItem
            button
            onClick={() => handlePageChange("Monitoring")}
            style={getNavItemStyle("Monitoring")}
          >
            <ListItemIcon style={getNavIconStyle("Monitoring")}>
              <RequestPageIcon />
            </ListItemIcon>
            <ListItemText primary="Management Cereri" />
          </ListItem>
          <ListItem
            button
            onClick={() => handlePageChange("StocManager")}
            style={getNavItemStyle("StocManager")}
          >
            <ListItemIcon style={getNavIconStyle("StocManager")}>
              <InventoryIcon />
            </ListItemIcon>
            <ListItemText primary="Stoc Management" />
          </ListItem>
          <ListItem
            button
            onClick={() => handlePageChange("Coupons")}
            style={getNavItemStyle("Coupons")}
          >
            <ListItemIcon style={getNavIconStyle("Coupons")}>
              <AccountBalanceIcon />
            </ListItemIcon>
            <ListItemText primary="Cupoane & Vouchere" />
          </ListItem>
          <ListItem
            button
            onClick={() => setShowAdministrativ(!showAdministrativ)}
            style={getToggleStyle(showAdministrativ)}
          >
            <ListItemIcon style={getToggleIconStyle(showAdministrativ)}>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Administrativ" />
            {showAdministrativ ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </ListItem>
          {showAdministrativ && (
            <List component="div" disablePadding style={{ marginBottom: 8 }}>
              <ListItem
                button
                onClick={() => handlePageChange("Page 4")}
                style={getNestedNavItemStyle("Page 4")}
              >
                <ListItemIcon style={getNavIconStyle("Page 4")}>
                  <BuildIcon />
                </ListItemIcon>
                <ListItemText primary="Tests" />
              </ListItem>
              <ListItem
                button
                onClick={() => handlePageChange("Contracte")}
                style={getNestedNavItemStyle("Contracte")}
              >
                <ListItemIcon style={getNavIconStyle("Contracte")}>
                  <BookIcon />
                </ListItemIcon>
                <ListItemText primary="Contracte" />
              </ListItem>
              <ListItem
                button
                onClick={() => handlePageChange("Page 3")}
                style={getNestedNavItemStyle("Page 3")}
              >
                <ListItemIcon style={getNavIconStyle("Page 3")}>
                  <GroupWorkIcon />
                </ListItemIcon>
                <ListItemText primary="Run Scripts" />
              </ListItem>
              <ListItem
                button
                onClick={() => handlePageChange("LuxuraAI")}
                style={getNestedNavItemStyle("LuxuraAI")}
              >
                <ListItemIcon style={getNavIconStyle("LuxuraAI")}>
                  <ScienceIcon />
                </ListItemIcon>
                <ListItemText primary="Luxura AI" />
              </ListItem>
              <ListItem
                button
                onClick={() => handlePageChange("Page 10")}
                style={getNestedNavItemStyle("Page 10")}
              >
                <ListItemIcon style={getNavIconStyle("Page 10")}>
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Dashbord Jira" />
              </ListItem>
              <ListItem
                button
                onClick={() => handlePageChange("vinted")}
                style={getNestedNavItemStyle("vinted")}
              >
                <ListItemIcon style={getNavIconStyle("vinted")}>
                  <ScienceIcon />
                </ListItemIcon>
                <ListItemText primary="Vinted" />
              </ListItem>
              <ListItem
                button
                onClick={() => handlePageChange("SeoAttributes")}
                style={getNestedNavItemStyle("SeoAttributes")}
              >
                <ListItemIcon style={getNavIconStyle("SeoAttributes")}>
                  <SearchIcon />
                </ListItemIcon>
                <ListItemText primary="SEO Atribute" />
              </ListItem>
              <ListItem
                button
                onClick={() => handlePageChange("SeoProducts")}
                style={getNestedNavItemStyle("SeoProducts")}
              >
                <ListItemIcon style={getNavIconStyle("SeoProducts")}>
                  <CategoryIcon />
                </ListItemIcon>
                <ListItemText primary="SEO Products" />
              </ListItem>
              <ListItem
                button
                onClick={() => handlePageChange("Waitinglist")}
                style={getNestedNavItemStyle("Waitinglist")}
              >
                <ListItemIcon style={getNavIconStyle("Waitinglist")}>
                  <NotificationsIcon />
                </ListItemIcon>
                <ListItemText primary="Waitinglist" />
              </ListItem>
            </List>
          )}
          <ListItem
            button
            onClick={() => setShowFinanciar(!showFinanciar)}
            style={getToggleStyle(showFinanciar)}
          >
            <ListItemIcon style={getToggleIconStyle(showFinanciar)}>
              <AttachMoneyIcon />
            </ListItemIcon>
            <ListItemText primary="Financiar" />
            {showFinanciar ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </ListItem>
          {showFinanciar && (
            <List component="div" disablePadding style={{ marginBottom: 8 }}>
              <ListItem
                button
                onClick={() => handlePageChange("Page 23")}
                style={getNestedNavItemStyle("Page 23")}
              >
                <ListItemIcon style={getNavIconStyle("Page 23")}>
                  <AssessmentIcon />
                </ListItemIcon>
                <ListItemText primary="Corectii" />
              </ListItem>
              <ListItem
                button
                onClick={() => handlePageChange("Investitii")}
                style={getNestedNavItemStyle("Investitii")}
              >
                <ListItemIcon style={getNavIconStyle("Investitii")}>
                  <AccountBalanceIcon />
                </ListItemIcon>
                <ListItemText primary="Investiții" />
              </ListItem>
              <ListItem
                button
                onClick={() => handlePageChange("Page 20")}
                style={getNestedNavItemStyle("Page 20")}
              >
                <ListItemIcon style={getNavIconStyle("Page 20")}>
                  <AssessmentIcon />
                </ListItemIcon>
                <ListItemText primary="Cum stam?" />
              </ListItem>
              <ListItem
                button
                onClick={() => handlePageChange("Page 22")}
                style={getNestedNavItemStyle("Page 22")}
              >
                <ListItemIcon style={getNavIconStyle("Page 22")}>
                  <AssessmentIcon />
                </ListItemIcon>
                <ListItemText primary="Receptii" />
              </ListItem>
              <ListItem
                button
                onClick={() => handlePageChange("Page 12")}
                style={getNestedNavItemStyle("Page 12")}
              >
                <ListItemIcon style={getNavIconStyle("Page 12")}>
                  <MenuBookIcon />
                </ListItemIcon>
                <ListItemText primary="Jurnale" />
              </ListItem>
              <ListItem
                button
                onClick={() => setShowAutoFacturi(!showAutoFacturi)}
                style={getToggleStyle(showAutoFacturi, true)}
              >
                <ListItemIcon style={getToggleIconStyle(showAutoFacturi)}>
                  <ReceiptIcon />
                </ListItemIcon>
                <ListItemText primary="Autofacturi" />
                {showAutoFacturi ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </ListItem>
              {showAutoFacturi && (
                <List component="div" disablePadding>
                  <ListItem
                    button
                    onClick={() => handlePageChange("Page 11")}
                    style={getNestedNavItemStyle("Page 11")}
                  >
                    <ListItemText primary="Crează Autofacturi" />
                  </ListItem>
                  <ListItem
                    button
                    onClick={() => handlePageChange("Page 12")}
                    style={getNestedNavItemStyle("Page 12")}
                  >
                    <ListItemText primary="Vizualizare Autofacturi" />
                  </ListItem>
                </List>
              )}
              <ListItem
                button
                onClick={() => setShowLLP(!showLLP)}
                style={getToggleStyle(showLLP, true)}
              >
                <ListItemIcon style={getToggleIconStyle(showLLP)}>
                  <CreditCardIcon />
                </ListItemIcon>
                <ListItemText primary="LLP" />
                {showLLP ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </ListItem>
              {showLLP && (
                <List component="div" disablePadding>
                  <ListItem
                    button
                    onClick={() => handlePageChange("Page 14")}
                    style={getNestedNavItemStyle("Page 14")}
                  >
                    <ListItemText primary="Comenzi" />
                  </ListItem>
                  <ListItem
                    button
                    onClick={() => handlePageChange("Page 15")}
                    style={getNestedNavItemStyle("Page 15")}
                  >
                    <ListItemText primary="Credite Active" />
                  </ListItem>
                </List>
              )}
              <ListItem
                button
                onClick={() => setShowDeconturi(!showDeconturi)}
                style={getToggleStyle(showDeconturi, true)}
              >
                <ListItemIcon style={getToggleIconStyle(showDeconturi)}>
                  <AccountBalanceIcon />
                </ListItemIcon>
                <ListItemText primary="Banci" />
                {showDeconturi ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </ListItem>
              {showDeconturi && (
                <List component="div" disablePadding>
                  <ListItem
                    button
                    onClick={() => handlePageChange("Page 16")}
                    style={getNestedNavItemStyle("Page 16")}
                  >
                    <ListItemText primary="Vizualizează Deconturi" />
                  </ListItem>
                  <ListItem
                    button
                    onClick={() => handlePageChange("Page 17")}
                    style={getNestedNavItemStyle("Page 17")}
                  >
                    <ListItemText primary="Încarcă Deconturi" />
                  </ListItem>
                </List>
              )}
              {/* New Scadentar entry */}
              <ListItem
                button
                onClick={() => handlePageChange("Scadentar")}
                style={getNestedNavItemStyle("Scadentar")}
              >
                <ListItemIcon style={getNavIconStyle("Scadentar")}>
                  <MenuBookIcon />
                </ListItemIcon>
                <ListItemText primary="Scadentar" />
              </ListItem>
              <ListItem
                button
                onClick={() => handlePageChange("ScadentarFurnizori")}
                style={getNestedNavItemStyle("ScadentarFurnizori")}
              >
                <ListItemIcon style={getNavIconStyle("ScadentarFurnizori")}>
                  <MenuBookIcon />
                </ListItemIcon>
                <ListItemText primary="Scadentar Furnizori" />
              </ListItem>
            </List>
          )}
          <ListItem
            button
            onClick={() => setShowAchiztii(!showAchiztii)}
            style={getToggleStyle(showAchiztii)}
          >
            <ListItemIcon style={getToggleIconStyle(showAchiztii)}>
              <ArticleIcon />
            </ListItemIcon>
            <ListItemText primary="ArticoleAI" />
            {showAchiztii ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </ListItem>
          {showAchiztii && (
            <List component="div" disablePadding>
              <ListItem
                button
                onClick={() => handlePageChange("Page 2")}
                style={getNestedNavItemStyle("Page 2")}
              >
                <ListItemText primary="Master Data" />
              </ListItem>
              <ListItem
                button
                onClick={() => handlePageChange("Page 18")}
                style={getNestedNavItemStyle("Page 18")}
              >
                <ListItemText primary="Calculator Pret Intrare" />
              </ListItem>
              <ListItem
                button
                onClick={() => handlePageChange("Page 19")}
                style={getNestedNavItemStyle("Page 19")}
              >
                <ListItemText primary="ArticoleAI" />
              </ListItem>
              <ListItem
                button
                onClick={() => handlePageChange("Page 21")}
                style={getNestedNavItemStyle("Page 21")}
              >
                <ListItemText primary="Analiza Stocuri" />
              </ListItem>
            </List>
          )}
        </List>
      </StyledDrawer>
      <MainContent>
        <ContentCard>{children}</ContentCard>
      </MainContent>
    </LayoutWrapper>
  );

  return (
    <AuthProvider>
      <AppBackground>
        <Router>
          <CssBaseline />
          {window.location.pathname !== "/cerere_restituit" && <TopBar />}
          <StyledContainer maxWidth="xl">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/cerere_restituit" element={<CerereRestituit />} />
              <Route path="/marketing" element={<MobileMarketingTags />} />
              <Route path="/scan" element={<MobileScan />} />
              {/* ✅ Ruta pentru pagina cu produse dintr-un folder */}
              <Route
                path="/folder/:folderId"
                element={
                  isMobile ? (
                    <MobileFolderProducts />
                  ) : (
                    <PrivateRoute>
                      {renderPageLayout(<FolderProducts />)}
                    </PrivateRoute>
                  )
                }
              />
              <Route
                path="/folder-group/:groupId"
                element={<MobileFolderProducts />}
              />
              <Route
                path="/product/:productId"
                element={<ProductsInventoryDetails />}
              />
              <Route
                path="/mobile-product/:productId"
                element={<MobileProductsInventoryDetails />}
              />

              {/* ✅ Ruta pentru Layer 2 */}
              <Route
                path="/layer2/:groupId"
                element={
                  isMobile ? (
                    <MobileStocManager />
                  ) : (
                    <PrivateRoute>
                      {renderPageLayout(<StocManagerLayer />)}
                    </PrivateRoute>
                  )
                }
              />

              {/* MobileFolderGroups ca landing page */}
              <Route
                path="/scadentar/payment-planned-check"
                element={
                  isMobile ? (
                    <ScadentarPaymentPlannedCheckPage />
                  ) : (
                    <PrivateRoute>
                      {renderPageLayout(<ScadentarPaymentPlannedCheckPage />)}
                    </PrivateRoute>
                  )
                }
              />
              <Route
                path="/scadentar-furnizori"
                element={
                  isMobile ? (
                    <ScadentarFurnizoriPage />
                  ) : (
                    <PrivateRoute>
                      {renderPageLayout(<ScadentarFurnizoriPage />)}
                    </PrivateRoute>
                  )
                }
              />
              <Route
                path="/scadentar-furnizori/furnizori/:vendorId"
                element={
                  isMobile ? (
                    <ScadentarFurnizorProfilePage />
                  ) : (
                    <PrivateRoute>
                      {renderPageLayout(<ScadentarFurnizorProfilePage />)}
                    </PrivateRoute>
                  )
                }
              />
              <Route
                path="/"
                element={
                  isMobile ? (
                    <MobileFolderGroups />
                  ) : (
                    <PrivateRoute>
                      {renderPageLayout(
                        <>
                          {currentPage === "MobileStocManager" && (
                            <MobileStocManager />
                          )}
                          {currentPage === "Page 10" && <Page10 />}
                          {currentPage === "Page 2" && <Page2 />}
                          {currentPage === "Page 4" && <Page4 />}
                          {currentPage === "Contracte" && <ContracteZoho />}
                          {currentPage === "Page 3" && <Page3 />}
                          {currentPage === "Page 7" && <Page7 />}
                          {currentPage === "Page 8" && <Page8 />}
                          {currentPage === "Page 9" && <Page9 />}
                          {currentPage === "Page 11" && <Page11 />}
                          {currentPage === "Page 12" && <Page12 />}
                          {currentPage === "Page 13" && <Page13 />}
                          {currentPage === "Page 14" && <Page14 />}
                          {currentPage === "Page 15" && <Page15 />}
                          {currentPage === "Page 16" && <Page16 />}
                          {currentPage === "Page 17" && <Page17 />}
                          {currentPage === "Page 18" && <Page18 />}
                          {currentPage === "Page 19" && <Page19 />}
                          {currentPage === "Scadentar" && <Scadentar />}
                          {currentPage === "ScadentarFurnizori" && (
                            <ScadentarFurnizoriPage />
                          )}
                          {currentPage === "Page 20" && <Page20 />}
                          {currentPage === "Page 21" && <Page21 />}
                          {currentPage === "Page 22" && <Page22 />}
                          {currentPage === "Page 23" && <Page23 />}
                          {currentPage === "Investitii" && <InvestitiiPage />}
                          {currentPage === "Monitoring" && <Monitoring />}
                          {currentPage === "vinted" && <Vinted />}
                          {currentPage === "StocManager" && <StocManager />}
                          {currentPage === "Coupons" && <Coupons />}
                          {currentPage === "LuxuraAI" && <LuxuraAIMain />}
                          {currentPage === "SeoAttributes" && (
                            <SEOAttributesPage />
                          )}
                          {currentPage === "SeoProducts" && <SEOProductsPage />}
                          {currentPage === "Waitinglist" && <WaitingListPage />}
                        </>
                      )}
                    </PrivateRoute>
                  )
                }
              />
            </Routes>
          </StyledContainer>
        </Router>
      </AppBackground>
    </AuthProvider>
  );
}

export default App;
